import { render, staticRenderFns } from "./dynamic-collection-loader.vue?vue&type=template&id=41225b01&"
import script from "./dynamic-collection-loader.vue?vue&type=script&lang=js&"
export * from "./dynamic-collection-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports